import script from "./MemberHomeWageMonthlySetting.vue?vue&type=script&setup=true&lang=ts"
export * from "./MemberHomeWageMonthlySetting.vue?vue&type=script&setup=true&lang=ts"

import "./MemberHomeWageMonthlySetting.vue?vue&type=style&index=0&id=6efe383e&lang=scss"

const __exports__ = script;

export default __exports__